export enum LogCategory {
    Auth = "Auth",
    Api = "Api",
    Core = "Core",
    WorkloadHooks = "WorkloadHooks",
    TeamHooks = "TeamHooks",
    Clipboard = "Clipboard",
    M365Health = "M365Health",
    Dashboard = "Dashboard",
    OpsGenieCopilot = "OpsGenieCopilot",
    IncidentDetail = "IncidentDetail",
    TabSelection = "TabSelection",
    Identity = "Identity",
    JobMgmt = "JobMgmt",
    RecoveryControlPanel = "RecoveryControlPanel",
    TorusWebDMS = "TorusWebDMS",
    Torus = "Torus",
    GriffinControlPlane = "GriffinControlPlane",
    AppHub = "AppHub"
}
